import i18n from "../../constants/i18n";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import { colors } from "../et3-theme/colors";
import TableTitle from "./TableTitle";

const EmptyTable = withLiteObserverAndTheme<{ width: number; title: string }>(
  (props) => {
    const { width, title, theme } = props;
    const { unitX } = theme;
    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={width}
        height={150}
        fDirection={"column"}
        color={colors.all.transparent}
        style={{}}
        alignItems="flex-start"
        justifyContent="center"
        onClick={() => {}}
      >
        <TableTitle width={width} title={title} />
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={width}
          height={100}
          fDirection={"column"}
          color={colors.all.white}
          style={{ borderRadius: 39 * unitX }}
          alignItems="center"
          justifyContent="center"
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={20}
            text={i18n.get("NO_RESULT")}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{}}
          />
        </ET3Div>
      </ET3Div>
    );
  }
);
export default EmptyTable;
